class Validator {
  static get operators () {
    return [{
      key: 'eq',
      label: '=',
      types: ['number', 'string'],
      resolve: (a, b) => a == b
    }, {
      key: 'notEq',
      label: '\u2260',
      types: ['number', 'string'],
      resolve: (a, b) => a != b
    }, {
      key: 'gt',
      label: '>',
      types: ['number'],
      resolve: (a, b) => a > b
    }, {
      key: 'gte',
      label: '\u2265',
      types: ['number'],
      resolve: (a, b) => a >= b
    }, {
      key: 'lt',
      label: '<',
      types: ['number'],
      resolve: (a, b) => a < b
    }, {
      key: 'lte',
      label: '\u2264',
      types: ['number'],
      resolve: (a, b) => a <= b
    }, {
      key: 'oneOf',
      label: 'one of',
      types: ['number', 'string'],
      enum: true,
      multiple: true,
      resolve: (a, b) => [].concat(b).includes(a)
    }, {
      key: 'notOneOf',
      label: 'not one of',
      types: ['number', 'string'],
      enum: true,
      multiple: true,
      resolve: (a, b) => !([].concat(b).includes(a))
    }, {
      key: 'has',
      label: 'has',
      types: ['numbers', 'strings'],
      resolve: (a, b) => a.includes(b)
    }, {
      key: 'notHas',
      label: 'doesn\'t have',
      types: ['numbers', 'strings'],
      resolve: (a, b) => !a.includes(b)
    }, {
      key: 'matches',
      label: 'matches',
      types: ['string'],
      resolve: (a, b) => {
        return a.toLowerCase().indexOf(b.toLowerCase()) !== -1
      }
    }, {
      key: 'format:legal',
      label: 'Legal',
      types: ['custom:legalFormats'],
      resolve: (a, b) => {
        const format = ([].concat(a)).find((f) => f.format === b)
        return format && format.result === 'legal'
      }
    }, {
      key: 'format:restricted',
      label: 'Restricted',
      types: ['custom:legalFormats'],
      resolve: (a, b) => {
        const format = ([].concat(a)).find((f) => f.format === b)
        return format && format.result === 'restricted'
      }
    }, {
      key: 'format:illegal',
      label: 'Illegal',
      types: ['custom:legalFormats'],
      resolve: (a, b) => {
        const format = ([].concat(a)).find((f) => f.format === b)
        return format && ['not_legal', 'banned'].includes(format.result)
      }
    }, {
      key: 'length',
      label: 'Size',
      returnType: 'number',
      resolve: (items) => ([].concat(...items)).length
    }, {
      key: 'sum',
      label: 'Sum',
      returnType: 'number',
      resolve: (items) => {
        return ([].concat(...items)).reduce((a, b) => a + b, 0)
      }
    }, {
      key: 'custom:mult',
      label: 'Sum (CMC)',
      returnType: 'number',
      resolve: (input) => {
        const r = input.reduce((a, b) => a + b[0] * b[1], 0)
        return r
      }
    }, {
      key: 'unique',
      label: 'Unique',
      returnType: 'strings',
      resolve: (input) => {
        return ([].concat(...input))
          // .map((item) => [].concat(item))
          .reduce((a, b) => {
            return a.concat(...b.filter((c) => !a.includes(c)))
          }, [])
      }
    }]
  }

  static get properties () {
    return [{
      key: 'quantity',
      label: 'Quantity',
      type: 'number'
    }, {
      key: 'card.type',
      label: 'Card Type',
      type: 'string',
      options: [
        { value: 'basicland',     label: 'Basic Land' },
        { value: 'land',          label: 'Land' },
        { value: 'planeswalker',  label: 'Planeswalker' },
        { value: 'instant',       label: 'Instant' },
        { value: 'sorcery',       label: 'Sorcery' },
        { value: 'artifact',      label: 'Artifact' },
        { value: 'enchantment',   label: 'Enchantment' },
        { value: 'creature',      label: 'Creature' }
      ]
    }, {
      key: 'board',
      label: 'Board',
      type: 'string',
      options: [
        { value: 'main',  label: 'Main' },
        { value: 'side',  label: 'Side' }
      ]
    }, {
      key: 'name',
      label: 'Name',
      type: 'string'
    }, {
      key: 'set',
      label: 'Set',
      type: 'string'
    }, {
      key: 'card.colors',
      label: 'Color(s)',
      type: 'strings',
      options: [
        { value: 'W', label: 'White' },
        { value: 'U', label: 'Blue' },
        { value: 'R', label: 'Red' },
        { value: 'B', label: 'Black' },
        { value: 'G', label: 'Green' }
      ]
    }, {
      key: 'card.cmc',
      label: 'Mana cost',
      type: 'number'
    }, {
      key: 'card.power',
      label: 'Power',
      type: 'number'
    }, {
      key: 'card.toughness',
      label: 'Toughness',
      type: 'number'
    }, {
      key: 'card.games',
      label: 'Game(s)',
      type: 'strings',
      options: [
        { value: 'arena', label: 'MTG Arena' },
        { value: 'paper', label: 'Paper' },
        { value: 'mtgo',  label: 'MTGO' }
      ]
    }, {
      key: 'card.legalFormats',
      label: 'Format',
      type: 'custom:legalFormats',
      options: [
        { value: 'standard',  label: 'standard',  },
        { value: 'future',    label: 'future',    },
        { value: 'frontier',  label: 'frontier',  },
        { value: 'modern',    label: 'modern',    },
        { value: 'legacy',    label: 'legacy',    },
        { value: 'pauper',    label: 'pauper',    },
        { value: 'vintage',   label: 'vintage',   },
        { value: 'penny',     label: 'penny',     },
        { value: 'commander', label: 'commander', },
        { value: 'duel',      label: 'duel',      },
        { value: 'oldschool', label: 'oldschool', }
      ]
    }]
  }

  static get reducers () {
    return [{
      key: 'length',
      label: 'Size',
      returnType: 'number',
      reduce: (items) => ([].concat(items)).length
    }, {
      key: 'sum',
      label: 'Sum',
      returnType: 'number',
      reduce: (items) => ([].concat(items)).reduce((a, b) => a + b, 0)
    }]
  }

  // Instance methods!
  evaluate (input, rules) {
    return rules.map((rule) => ({
      key: rule.key,
      label: rule.label,
      result: this.resolveExpression(input, rule)
    }))
  }
  resolveParameter (parameter, input, source) {
    const param = this.resolveParameterConfig(parameter)
    switch (parameter.type) {
      case 'expression':
        return this.resolveExpression(source, param)
      case 'property':
        // try {
          return this.extractPath(input, param.path || param.key)
        // } catch (err) {
        //   console.log('Fuck this shit')
        //   debugger
        // }
      case 'literal':
      default:
        return param
    }
  }
  resolveParameters(params, input, source) {
    return params.map((p) => this.resolveParameter(p, input, source))
  }
  resolveParameterConfig(parameter) {
    const { type, value } = parameter
    switch (type) {
      case 'property':
        return Validator.properties.find(({ key }) => key === value)
      case 'expression':
        // return this.config.expressions.find(({ key }) => key === value)
      // case 'literal':
      // default:
      //   return value;
    }
    return value
  }
  resolveExpression(input, expression) {
      const source = expression.with
          ? this.resolveParameter({ type: 'expression', value: expression.with }, input, input)
          : input;
      const track = { matches: source }
      return expression.sequence
          .reduce((a, b) => {
          return this.resolveStep(a, b, source, track);
      }, source);
  }
  resolveStep(input, step, source, track) {
      const operator = Validator.operators
          .find(({ key }) => key === step.operator); // @todo
      let result = null;
      const { type, parameters } = step;
      // console.log('Step', type, operator)
      switch (type) {
          case 'filter':
              track.matches = result = input.filter((i) => {
                  const params = this.resolveParameters(parameters, i, source);
                  return operator.resolve(...params); // && !!inverse
              });
              break;
          case 'map': // @todo?
              result = input.map((i) => {
                  return this.resolveParameters(parameters, i, source);
              });
              break;
          case 'reduce':
          case 'assert': {
              const params = this.resolveParameters(parameters, input, source);
              result = operator.resolve(input, ...params); // @todo inverse?
              if (type === 'assert') {
                  return {
                    result,
                    input,
                    matches: track.matches,
                    params
                  }
              }
              break;
          }
      }
      return result;
  }
  extractPath(input, path) {
      return path.split('.')
          .reduce((a, b) => a[b], input);
      // return path
      //   .split(/(?:[.\[\]])+/)
      //   .filter((part) => part !== '')
      //   .reduce((a: any, b, idx, parts) => {
      //     if (Array.isArray(a) && isNaN(Number(b))) {
      //       const fork = parts.splice(idx).join('.')
      //       return a.map((c) => this.extractPath(c, fork)).flat()
      //     }
      //     return a && a[b]
      //   }, input)
  }
}

export default Validator
